import React from 'react';
import {Checkbox, FormControlLabel} from '@material-ui/core';
import PropTypes from 'prop-types';
import {ReactComponent as UncheckedIcon} from '../../assets/icons/uncheckedIcon.svg';
import {ReactComponent as CheckedIcon} from '../../assets/icons/checkedIcon.svg';
import {ReactComponent as StrokeIcon} from '../../assets/icons/uncheckedIconStroke.svg';

import './CheckboxMUI.scss';

const CheckboxMUI = ({
  className = '',
  checked,
  checkedIcon = <CheckedIcon />,
  color = 'default',
  disabled = false,
  disableRipple = false,
  defaultChecked,
  icon = <UncheckedIcon />,
  id,
  type = 'default',
  indeterminate = false,
  inputProps,
  inputRef,
  onChange,
  padding = false,
  required = false,
  size = 'medium',
  value,
  label,
  ...props
}) => {
  return (
    <FormControlLabel
      className={className}
      classes={{
        root: `checkbox-mui-label${padding ? ' checkbox-mui-label--padding' : ''}`
      }}
      control={
        <Checkbox
          className={className}
          classes={{
            root: `checkbox-mui${padding ? ' checkbox-mui--padding' : ''}`,
            checked: 'checkbox-mui--checked',
            disabled: 'checkbox-mui--disabled',
            indeterminate: 'checkbox-mui--indeterminate',
            colorPrimary: 'checkbox-mui-color--primary',
            colorSecondary: 'checkbox-mui-color--secondary'
          }}
          checked={checked}
          checkedIcon={checkedIcon}
          icon={type === 'default' ? icon : <StrokeIcon />}
          color={color}
          disabled={disabled}
          disableRipple={disableRipple}
          defaultChecked={defaultChecked}
          id={id}
          inputProps={inputProps}
          inputRef={inputRef}
          onChange={onChange}
          required={required}
          size={size}
          value={value}
          {...props}
        />
      }
      label={label}
    />
  );
};

CheckboxMUI.propTypes = {
  checked: PropTypes.bool,
  checkedIcon: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),
  type: PropTypes.oneOf(['default', 'stroke']),
  defaultChecked: PropTypes.bool,
  disableRipple: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  id: PropTypes.string,
  indeterminate: PropTypes.bool,
  inputProps: PropTypes.object,
  inputRef: PropTypes.any,
  onChange: PropTypes.func,
  padding: PropTypes.bool,
  required: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
  value: PropTypes.any,
  label: PropTypes.node
};

export default CheckboxMUI;
